import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'

const ModalFooter3 = (props) => (
  <Modal.Footer
    className={props.className}
  >
    {props.children}
  </Modal.Footer>
)

ModalFooter3.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string.isRequired
}

ModalFooter3.defaultProps = {
  className: ''
}

export default ModalFooter3
